/**
 * Fixture Page Constants
 * Centralized constants for the Fixtures feature
 */

// Initial filter state
export const INITIAL_FILTERS = {
  phases: [],
  brackets: [],
  pitches: [],
  teams: [],
  categories: [],
};

// Initial date range (defaults to competition start/end, falls back to current week)
export const getInitialDateRange = (tournament) => {
  const compStart = tournament?.matchSchedule?.startDate;
  const compEnd = tournament?.matchSchedule?.endDate;

  if (compStart && compEnd) {
    const toDateStr = (d) => new Date(d).toISOString().split('T')[0];
    return {
      startDate: toDateStr(compStart),
      endDate: toDateStr(compEnd),
    };
  }

  const today = new Date();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  return {
    startDate: startOfWeek.toISOString().split('T')[0],
    endDate: endOfWeek.toISOString().split('T')[0],
  };
};

// View modes
export const VIEW_MODES = {
  LIST: 'list',
  CALENDAR: 'calendar',
};

// Fixture status types
export const FIXTURE_STATUS = {
  PENDING: 'PENDING',
  SCHEDULED: 'SCHEDULED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

// Result status for display
export const RESULT_STATUS = {
  PENDING: 'pending',
  FINAL: 'Final Score',
  VERIFY: 'Verify Result',
};

// Event types for results
export const EVENT_TYPES = {
  GOAL: 'Goal',
  PENALTY: 'Penalty',
  YELLOW_CARD: 'Yellow Card',
  RED_CARD: 'Red Card',
  SUBSTITUTION: 'Substitution',
};

// Default pitch colors for calendar view
export const PITCH_COLORS = [
  'linear-gradient(135deg, #1a1a1a 0%, #2196F3 100%)',
  'linear-gradient(135deg, #1a1a1a 0%, #1976D2 100%)',
  'linear-gradient(135deg, #1a1a1a 0%, #0D47A1 100%)',
  'linear-gradient(135deg, #1a1a1a 0%, #1565C0 100%)',
  'linear-gradient(135deg, #1a1a1a 0%, #1E88E5 100%)',
];

// Helper to get pitch color by name
export const getPitchColor = (pitchName) => {
  if (!pitchName) return PITCH_COLORS[0];
  const index = pitchName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % PITCH_COLORS.length;
  return PITCH_COLORS[index];
};

// Date shift amounts (in days)
export const DATE_SHIFT = {
  DAY: 1,
  WEEK: 7,
};
